import React from "react";
import { Heart } from "lucide-react";
import { FacebookIcon, InstagramIcon, TikTokIcon } from "./NavIcons";

const socialLinks = [
  { id: "facebook", label: "Facebook", href: "#", Icon: FacebookIcon },
  { id: "instagram", label: "Instagram", href: "#", Icon: InstagramIcon },
  { id: "tiktok", label: "TikTok", href: "#", Icon: TikTokIcon },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">MEDEASE NEPAL</div>
            <p className="footer-tagline">
              Precision Care. Elevated Living.<br />
              Nepal's premier biomedical catalog.
            </p>
            <div className="footer-url">www.medeasenepal.com.np</div>
            <a href="tel:+9779716886567" className="footer-phone">+977 971-688-6567</a>
          </div>

          <div className="footer-links-group">
            <div className="footer-links-title">Collections</div>
            <div className="footer-links">
              <span>Premium</span>
              <span>Mid-Range</span>
              <span>Mobility</span>
              <span>Monitoring</span>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-links-title">Experts</div>
            <div className="footer-links">
              <span>Dr. Astha Ghimire</span>
              <span>Er. Ashok Paudel</span>
              <span>Consultations</span>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-links-title">Support</div>
            <div className="footer-links">
              <a
                href="https://wa.me/9779716886567?text=Hello%20MedEase%20Nepal%2C%20I%20would%20like%20to%20inquire%20about%20medical%20equipment."
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
              <span>Email</span>
              <span>Product Guide</span>
              <span>Machine Info</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copy">
            © 2024 MedEase Nepal. All rights reserved.
          </div>
          <div className="footer-social" aria-label="Social media">
            {socialLinks.map(({ id, label, href, Icon }) => (
              <a
                key={id}
                href={href}
                className="footer-social-link"
                aria-label={label}
                onClick={(e) => e.preventDefault()}
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
          <div className="footer-made">
            Made with <Heart size={12} fill="#1f4d3d" color="#1f4d3d" /> for better healthcare
          </div>
        </div>
      </div>
    </footer>
  );
}
